import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
} from '@chakra-ui/react';
import React, { useEffect, useMemo } from 'react';

import { Select } from './Select';

/**
 * a select component that lets you select from given options
 * But also adds a "custom" that lets you input a custom value
 */
export const SelectWithCustomOption = ({
  value,
  errorMessage,
  onChange,
  options,
  customInputLabel,
  defaultCustomValue,
}: {
  defaultCustomValue: string;
  customInputLabel: string;
  value: string;
  errorMessage?: string;
  onChange: (updated: string) => void;
  options: {
    label: string | React.ReactNode;
    value: string;
    icon?: React.ReactElement;
  }[];
}) => {
  const optionsWithCustom = useMemo(() => {
    return options.concat({ label: customInputLabel, value: 'custom' });
  }, [customInputLabel, options]);

  const [selectedOption, setSelectedOption] = React.useState<string>('custom');
  const [customFormat, setCustomFormat] = React.useState<string>(
    defaultCustomValue,
  );

  useEffect(() => {
    const updatedSelectedOption =
      optionsWithCustom.find(({ value: optionValue }) => optionValue === value)
        ?.value ?? 'custom';

    setSelectedOption(updatedSelectedOption);
    if (updatedSelectedOption === 'custom') {
      setCustomFormat(value);
    }
  }, [optionsWithCustom, value]);

  const updateSelection = (newValue: string | undefined) => {
    if (newValue === undefined) {
      return;
    }
    setSelectedOption(newValue);

    if (newValue === 'custom') {
      onChange(customFormat);
    } else {
      onChange(newValue);
    }
  };

  return (
    <>
      <FormControl isInvalid={!!errorMessage}>
        <FormLabel>Date Format</FormLabel>
        <Select
          value={selectedOption}
          options={optionsWithCustom}
          onChange={updateSelection}
          width="100%"
        />
      </FormControl>
      {selectedOption === 'custom' && (
        <FormControl isInvalid={!!errorMessage}>
          <FormLabel>{customInputLabel}</FormLabel>
          <Input
            type="text"
            value={value}
            onChange={(e) => {
              setCustomFormat(e.target.value);
              onChange(e.target.value);
            }}
          />
          <FormErrorMessage>{errorMessage}</FormErrorMessage>
        </FormControl>
      )}
    </>
  );
};
